import(/* webpackMode: "eager" */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/[locale]/homepage/components/CustomerTestimonials.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/[locale]/homepage/components/FeaturedVehicles.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/[locale]/homepage/components/HeroSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/app/[locale]/homepage/components/InstantBookingWidget.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/common/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/common/Header.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/common/PageTransition.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/ui/AppIcon.tsx");
;
import(/* webpackMode: "eager" */ "/home/ubuntu/download/6970ef661beda80014757590/carrentpro/src/components/ui/AppImage.tsx");
